import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useGate, useUnit } from 'effector-react';
import { IconButton, Badge, Tooltip } from '@mui/material';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import { NewsFeedGate, onClickBadge, $unreadCount } from '../model';
import { NewsPreview } from '../organisms';

export const NewsFeedBadge = () => {
  const [unreadCount] = useUnit([$unreadCount]);
  const iconButtonRef = useRef<HTMLButtonElement | null>(null);
  const { t } = useTranslation();

  const onClick = () => {
    onClickBadge();
  };

  useGate(NewsFeedGate);

  return (
    <>
      <Tooltip title={t('NewsFeed')}>
        <IconButton onClick={onClick} ref={iconButtonRef}>
          <Badge badgeContent={unreadCount} color="primary">
            <StickyNote2OutlinedIcon />
          </Badge>
        </IconButton>
      </Tooltip>
      <NewsPreview anchorEl={iconButtonRef.current} />
    </>
  );
};
